import { Box, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import ApiIcon from "legacy-components/icons/ApiIcon";
import React from "react";
import { useHistory } from "react-router";
import { NavLink } from "react-router-dom";

export const ApiNavigation: React.FC = () => {
  const { push } = useHistory();
  return (
    <NavLink
      className="navigation-tab"
      key={"apis"}
      activeClassName="active"
      to={"/home/apis"}
    >
      <ListItem button onClick={() => push("/home/apis")}>
        <ListItemIcon>
          <ApiIcon style={{ color: "#fff" }} />
        </ListItemIcon>
        <ListItemText
          className="sub-menu-text"
          primary={
            <Box display="flex">
              <Box flexGrow={1}>Apis</Box>
            </Box>
          }
        />
      </ListItem>
    </NavLink>
  );
};
